/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Space, Button, Card, Popconfirm, Layout, Table, Input } from "antd";
import { ALL_COUPON, DELETE_COUPON } from "../../constants/api";

function CouponTable() {
  const { Content } = Layout;
  const navigate = useNavigate();
  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        const formattedData = data["data"].map((row, index) => ({
          key: index,
          ID: index + 1,
          coupon_code: row.coupon_code,
          coupon_value: row.coupon_value,
          coupon_value_type: row.coupon_value_type,
          coupon_start: row.start_date,
          coupon_end: row.end_date,
          minimum_amount: row.minimum_amount,
          title: row.title,

          Action: (
            <Space>
              <Button
                onClick={() => {
                  navigate("/coupon/edit/" + row.id);
                }}
                block
              >
                Edit
              </Button>
              <Popconfirm
                title="Delete the data"
                description="Are you sure to delete this data?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button danger>Delete</Button>
              </Popconfirm>
            </Space>
          ),
        }));
        setState(formattedData);
        setFilteredState(formattedData); // Set the initial filtered data
      } else {
        setState([]);
        setFilteredState([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredState([]);
      setLoading(false);
    };
    getAPI(ALL_COUPON, successFn, errorFn, {});
  };

  const deleteData = (values) => {
    setLoading(true);
    let data = { id: values };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getList();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_COUPON, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (slider) =>
        slider.title.toLowerCase().includes(value.toLowerCase()) ||
        slider.coupon_code.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredState(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: 150,
    },
    {
      title: "Coupon Code",
      dataIndex: "coupon_code",
      width: 50,
    },
    {
      title: "Coupon Value",
      dataIndex: "coupon_value",
      width: 50,
    },
    {
      title: "Coupon V.Type",
      dataIndex: "coupon_value_type",
      width: 50,
    },
    {
      title: "Coupon Start",
      dataIndex: "coupon_start",
      width: 50,
    },
    {
      title: "Coupon End",
      dataIndex: "coupon_end",
      width: 50,
    },
    {
      title: "Minimum Amount",
      dataIndex: "minimum_amount",
      width: 50,
    },

    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Manage Coupon"
          extra={
            <Space>
              <Input
                placeholder="Search by Name"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 300 }}
              />
              <Button onClick={() => navigate("/coupon/add")}>
                Add <PlusOutlined />
              </Button>
            </Space>
          }
          bordered
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState} // Use filtered state
            pagination={{ pageSize: 10 }}
            scroll={{ x: 240 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default CouponTable;
